/* eslint-disable react/no-children-prop */
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import { useContext } from 'react';
import { TextContext } from './Context';

const ViewingPad = () => {
  const { text } = useContext(TextContext);
  return (
    <div className="markdown-viewing-pad-container">
      <p className="markdown-viewing-pad">
        <ReactMarkdown remarkPlugins={[gfm]} children={text} skipHtml />
      </p>
    </div>
  );
};

export default ViewingPad;
